import React from 'react';
import { AlertTriangleIcon, MailIcon, PlugZapIcon } from 'lucide-react';
import type { FormStatus } from '../../hooks/useInquiryForm';
import { buttonClasses } from '../../utils/buttonStyles';
interface FormStatusNoticeProps {
  status: FormStatus;
  message: string;
  mailtoHref: string;
  attachmentNote?: boolean;
}
export function FormStatusNotice({
  status,
  message,
  mailtoHref,
  attachmentNote = false
}: FormStatusNoticeProps) {
  if (status === 'not_configured') {
    return <div role="status" className="rounded-xl border-l-2 border-copper bg-limestone p-5" data-id="element-156" data-mp="3n6zmb15hvwts">
        <div className="flex gap-3" data-id="element-157" data-mp="3igj8vh1ocb7f">
          <PlugZapIcon className="mt-0.5 h-5 w-5 shrink-0 text-copper-deep" aria-hidden="true" data-id="element-158" data-mp="3ifhwn98x9io4" />
          <div data-id="element-159" data-mp="3dgww18prcwz5">
            <p className="font-display font-semibold text-aubergine" data-id="element-160" data-mp="3dh6kgrv5mw2q">Online submission isn’t connected yet</p>
            <p className="mt-1.5 text-sm leading-relaxed text-plum/75" data-id="element-161" data-mp="et0vedxdr1n5">
              Nothing has been sent. You can reach our team now with a pre-filled email draft — review it in your email app before sending.
              {attachmentNote && ' Please attach your CV to the email if you would like to share it.'}
            </p>
            <a href={mailtoHref} className={buttonClasses('dark', 'sm', 'mt-4')} data-id="element-162" data-mp="22174kqsblqeq">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="21z4fc8yzs1b2" />
              Open Email Draft
            </a>
          </div>
        </div>
      </div>;
  }
  if (status === 'error') {
    return <div role="alert" className="flex gap-3 rounded-xl border border-danger/30 bg-danger/5 p-5 text-sm text-danger" data-id="element-164" data-mp="1s5419hlqflq7">
        <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-165" data-mp="1j2cs5ogbx21q" />
        <p className="leading-relaxed" data-id="element-166" data-mp="1o1661hzj2v2f">{message}</p>
      </div>;
  }
  return null;
}